export enum PersonaQuePaga {
  PERSONA_ACTUAL = 'personaActual',
  OTRA_PERSONA = 'otraPersona',
}
